import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import TeacherForm from "./pages/TeacherForm";
import AdminLogin from "./pages/AdminLogin";
import SetPassword from "./pages/SetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPaperSession from "./pages/AdminPaperSession";
import SchoolLogsPage from "./pages/SchoolLogsPage";
import { auth } from "./lib/api";

function RequireAdmin({ children }) {
  if (!auth.isAuthed()) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
      <Routes>
        <Route path="/" element={<TeacherForm />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/set-password" element={<SetPassword />} />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/paper-session"
          element={
            <RequireAdmin>
              <AdminPaperSession />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/schools/:schoolName"
          element={
            <RequireAdmin>
              <SchoolLogsPage />
            </RequireAdmin>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
